(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bhq-request-readability"] && !Shopify.designMode) return;
  try {
    
(() => {
  const repair = () => {
    for (const email of document.querySelectorAll('input[placeholder="your@email.com"]')) {
      let panel = email.parentElement;
      for (let depth = 0; panel && depth < 8; depth++, panel = panel.parentElement) {
        if (panel === document.body) break;
        if (panel.querySelector('textarea') && panel.querySelectorAll('input').length >= 3 && panel.textContent.includes('Request a Quote')) {
          panel.classList.add('bhq-quote-panel');
          break;
        }
      }
    }
  };
  repair();
  new MutationObserver(repair).observe(document.body, { childList: true, subtree: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bhq-storefront"] && !Shopify.designMode) return;
  try {
    
(() => {
const initialized = new WeakSet();
const setup = () => document.querySelectorAll('[data-bhq-slider]').forEach(root => {
if (initialized.has(root)) return;
initialized.add(root);
const slides = [...root.querySelectorAll('.bhq-category-slide')];
if (slides.length < 2) return;
let index = 0, paused = matchMedia('(prefers-reduced-motion: reduce)').matches, hover = false;
const pause = root.querySelector('[data-pause-button]');
const label = () => { pause.textContent = paused ? '▶' : 'Ⅱ'; pause.setAttribute('aria-label',paused ? root.dataset.play : root.dataset.pause); };
const show = delta => { index=(index+delta+slides.length)%slides.length;slides.forEach((slide,i)=>{slide.hidden=i!==index;});root.querySelector('[data-count]').textContent=(index+1)+' / '+slides.length; };
root.querySelector('[data-prev]').addEventListener('click',()=>show(-1));
root.querySelector('[data-next]').addEventListener('click',()=>show(1));
pause.addEventListener('click',()=>{paused=!paused;label();});
root.addEventListener('mouseenter',()=>{hover=true;});
root.addEventListener('mouseleave',()=>{hover=false;});
label();
const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}if(!paused&&!hover&&!document.hidden&&!root.contains(document.activeElement))show(1);},5000);
});
setup();document.addEventListener('shopify:section:load',setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
